module.exports = __webpack_public_path__ + "static/media/4.2af5fb0f.jpg";